import { read, utils, WorkSheet, write, writeFile } from "xlsx";
import { UserFromFileType } from "../types/UserFromFileType";
import { saveAs } from "file-saver";
import SafeairManager from "../../../../../../../util/api/SafeairManager";
import { OrganizationType } from "../types/OrganizationType";
import { APIs } from "../../../../../../../util/api/APIs";
import { UserType } from "../types/UserType";

class CreateUserService {
  async readFile(file: File) {
    var f = file;
    var name = f.name;
    const reader = new FileReader();
    const data: UserFromFileType[] = await new Promise((res, rej) => {
      reader.onload = (evt) => {
        // evt = on_file_select event
        /* Parse data */
        if (evt != null && evt.target != null) {
          const bstr = evt.target.result;
          const wb = read(bstr, { type: "binary" });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = utils.sheet_to_json(ws);
          /* Update state */
          res(data as UserFromFileType[]);
        } else {
          rej();
        }
      };
      reader.readAsBinaryString(f);
    });
    return data;
  }

  getSheetData(data: any[], header: string[]) {
    var fields = Object.keys(data[0]);
    var sheetData = data.map(function (row) {
      return fields.map(function (fieldName) {
        return row[fieldName] ? row[fieldName] : "";
      });
    });
    sheetData.unshift(header);
    return sheetData;
  }

  async saveAsExcel(dataSets: any) {
    // var data = [
    //   { name: "John", city: "Seattle" },
    //   { name: "Mike", city: "Los Angeles" },
    //   { name: "Zach", city: "New York" }
    // ];
    // let header = ["Name", "City"];
    const worksheets: WorkSheet[] = [];
    var fileName = `medical-emergency-${new Date().toISOString()}.xlsx`;

    dataSets.forEach((dataSet: any) => {
      var workSheet = utils.json_to_sheet(dataSet);
      worksheets.push(workSheet);
    });

    var wb = utils.book_new();

    worksheets.forEach((_worksheet: any, index) =>
      utils.book_append_sheet(wb, _worksheet, `medical-emergency-${index}`)
    );

    var bin = write(wb, { bookType: "xlsx", type: "binary" });

    return writeFile(wb, fileName, {
      bookType: "xlsx",
    });
    // /return new Blob([excelBu], { type: "" });
  }
  async updateUserByAdmin(body: {
    username: string;
    email: string;
    name: string;
    familyName: string;
    customType: string;
    gender: string;
    phoneNumber?: string;
  }) {
    const users = await SafeairManager.invoke({
      api: APIs.User.updateUserAttributesByAdmin,
      parameters: null,
      body
    });
    return users;
  }

  async getOrganizations() {
    const response = await SafeairManager.invoke({
      api: APIs.Organization.ListAllOrganizations,
      parameters: null,
      body: {},
    });
    return response.data as OrganizationType[];
  }

  async getOrgByUserName(name: string) {
    const response = await SafeairManager.invoke({
      api: APIs.Organization.OrgByUserName,
      parameters: {
        username: name
        
      },
      body: {},
    });
    return response.data;
  }


  async createUser(body: {
    username: string;
    email: string;
    name: string;
    familyName: string;
    customType: string;
    gender: string;
    organizationId: number;
    phoneNumber?: number;
  }) {
    const userCreationResponse = await SafeairManager.invoke({
      api: APIs.User.CreateUser,
      parameters: null,
      body,
    });
    return userCreationResponse.data;
  }

  async updateConfirmStatus(
    isApproved: string,username:any) {
    const users = await SafeairManager.invoke({
      api: APIs.User.updateUserStatus,
      parameters: {
        username,
        isApproved
      },
      body:null
    });
    return users;
  }
}

export default new CreateUserService();
